import { useEffect, useState } from "react";
import DataTable from "../../component/DataTable";
import { Link } from "react-router-dom";
import ApiRequest from "../../helper/ApiRequest";
import { ApiEndpoints } from "../../helper/ApiEndpoints";
import { toast } from "react-toastify";
import AdminHeader from "../../component/AdminHeader";

const DeleteEndpoint = ApiEndpoints.infographics.Delete;
const ListEndpoint = ApiEndpoints.infographics.List;
const EditPath = "edit-infographic";
const tableHeader = ["Date", "Title"];
const tbody = ["createdAt", "title"];

export default function Infographic() {

  const [data, setData] = useState([]);

  const dataFetch = async () => {
    try {
      const response = await ApiRequest("GET", ListEndpoint);
      const result = response.infographics;
      setData(result);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    dataFetch();
  }, []);

  const handleDelete = async (infographic_id) => {
    const payload = { infographic_id };
    try {
      const response = await ApiRequest("POST", DeleteEndpoint, payload);
      toast.success(response.message)
      dataFetch();
    } catch (error) {
      console.error(error);
    }
  };

  const pagename = {
    name: 'Infographic Management',
    user: 'Admin',
    innerpage: 'Infographic Management / Infographics'
  }

  return (
    <>
      <AdminHeader pagename={pagename} />

      <div className="add-btn-section">
        <Link className="admin-add-btn" to="/add-infographic">Add +</Link>
        <DataTable
          data={data}
          tableHeader={tableHeader}
          tbody={tbody}
          editPath={EditPath}
          onDelete={handleDelete}
        />
      </div>
    </>
  );
}
